<template>
  <div id="subpage">
    <el-col :span="24" class="warp-breadcrum">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item>
          <b>房车管理</b>
        </el-breadcrumb-item>
        <el-breadcrumb-item>房车列表</el-breadcrumb-item>
      </el-breadcrumb>
    </el-col>
    <div class="content">
      <div class="xcx-head">
        <div style="display: flex">
          <span>房车列表</span>
        </div>
      </div>
      <div class="search-box mt10">
        <el-form :inline="true">
          <el-form-item>
            <el-input placeholder="请输入关键词" v-model="search.keys"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button @click="getIndex()" icon="el-icon-search" type="primary">查询</el-button>
          </el-form-item>
          <el-form-item>
            <el-button @click="getClearIndex()" icon="el-icon-delete" type="info">清空筛选</el-button>
          </el-form-item>
        </el-form>
      </div>
      <div class="xcx-content">
        <!--列表-->
        <el-table
          border
          :data="tableData"
          style="width: 100%"
          row-key="id"
          v-loading="loading"
          default-expand-all
          :tree-props="{ children: 'children', hasChildren: 'hasChildren' }"
        >
          <!-- <el-table-column prop="id" label="ID" width="100"></el-table-column> -->
          <el-table-column prop="brand_title" label="品牌" width="120"></el-table-column>
          <el-table-column prop="model_v" label="车型" width="120"></el-table-column>
          <el-table-column prop="type_v" label="型号" width="140"></el-table-column>
          <el-table-column prop="devid" label="DID" width="100"></el-table-column>
          <el-table-column prop="dev_id" label="MID" width="120"></el-table-column>
          <el-table-column label="联网状态" width="80">
            <template slot-scope="scope">
              <el-link v-if="scope.row.is_online == 1" type="success" :underline="false">在线</el-link>
              <el-link v-else type="danger" :underline="false">离线</el-link>
            </template>
          </el-table-column>
          <el-table-column prop="times" label="时长" width="100"></el-table-column>
          <el-table-column prop="maps" label="位置"></el-table-column>
          <el-table-column label="里程" width="80">0</el-table-column>
          <el-table-column prop="load_time" label="出厂日期 " width="160"></el-table-column>
          <el-table-column label="操作" width="120" fixed="right">
            <template slot-scope="scope">
              <el-dropdown @command="handleCommand">
                <span class="el-dropdown-link">
                  操作
                  <i class="el-icon-arrow-down el-icon--right"></i>
                </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item :command="beforeHandleCommand(scope.row.id, 'edit')">编辑</el-dropdown-item>
                  <el-dropdown-item :command="beforeHandleCommand(scope.row.id, 'del')">删除</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </template>
          </el-table-column>
        </el-table>
        <!--分页-->
        <div class="paging">
          <el-pagination
            class="left"
            @current-change="handleCurrentChange"
            :current-page="page"
            background
            layout="prev, pager, next"
            :total="count"
          ></el-pagination>
        </div>
      </div>
    </div>

  </div>
</template>
<script>
import UploadOne from "../../components/upload/UploadOne";
export default {
  components: {
    UploadOne,
  },
  data() {
    return {
      loading: true,
      id: "",
      tableData: [],
      page: 0,
      count: 0,
      limit: 30,
      dialogFormVisible: false,
      ruleForm: {
        thumb: "",
        m_thumb: "",
        title: "",
      },
      search: {
        keys: "",
      },
      rules: {
        thumb: [
          {
            required: true,
            message: "请上传图片",
            trigger: "blur",
          },
        ],
        title: [{ required: true, message: "请输入名称", trigger: "blur" }],
      },
      formLabelWidth: "120px",
    };
  },
  //进入页面加载
  mounted: function () {
    var that = this;
    that.getList();
  },
  methods: {
    beforeHandleCommand(row, command) {
      return {
        row: row,
        command: command,
      };
    },
    handleCommand(command) {
      console.log(command);
      switch (command.command) {
        case "edit":
          var that = this;
          that.id = command.row;
          that.getComBrand();
          that.axios.post("/dev/edit", { id: command.row }).then((res) => {
            if (res) {
              that.ruleForm = res.data;
              that.dialogFormVisible = true;
            }
          });
          break;
        case "del":
          this.del_item(command.row);
          break;
      }
    },
    getIndex() {
      this.getList();
    },
    getClearIndex() {
      this.search.keys = "";
      this.getList();
    },
    edit(ids) {
      var that = this;
      that.id = ids;
      that.axios.post("/banner/edit", { id: ids }).then((res) => {
        if (res) {
          that.ruleForm = res.data;
          that.dialogFormVisible = true;
        }
      });
    },
    /**
     * 下一页
     */
    handleCurrentChange(currentPage) {
      var that = this;
      that.page = currentPage;
      that.getList();
    },
    del_item(ids) {
      let that = this;
      this.$confirm("此操作不可逆, 是否继续?", "温馨提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          that.axios
            .post("/banner/destroy", {
              ids: ids,
            })
            .then((res) => {
              console.log(res);
              if (res.code == 200) {
                this.$message({
                  type: "success",
                  message: res.msg,
                });
                that.getList();
              } else {
                this.$message({
                  type: "info",
                  message: res.msg,
                });
              }
            });
        })
        .catch(() => {});
    },
    /**
     * 获取列表
     */
    getList() {
      let that = this;
      let formData = {};
      var curr_page = sessionStorage.getItem("curr_page");
      that.page = curr_page ? curr_page - 0 : that.page;
      formData.page = that.page;
      formData.limit = that.limit;
      formData.keys = that.search.keys;
      that.axios.post("/car/index", formData).then((res) => {
        if (res) {
          that.tableData = res.data.data;
          that.count = res.data.total;
          that.page = curr_page ? curr_page : that.page;
          curr_page ? sessionStorage.removeItem("curr_page") : "";
        }
        that.loading = false;
      });
    },
    /**
     * 提交信息
     */
    submitForm(formName) {
      const that = this;
      that.$refs[formName].validate((valid) => {
        if (!valid) return that.$message.warning("请完整填写内容!");
        var formData = {};
        formData = that.ruleForm;
        var url = "/banner/store";
        if (that.id) {
          formData.id = that.id;
          url = "/banner/update";
        }
        that.axios.post(url, formData).then(() => {
          that.$message.success(that.id ? "修改成功" : "添加成功");
          that.dialogFormVisible = false;
          that.getList();
        });
      });
    },
  },
};
</script>
<style>
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 120px;
  height: 120px;
  line-height: 120px;
  text-align: center;
}

.avatar {
  width: 120px;
  height: 120px;
  display: block;
}

.search-box {
  padding: 0 20px;
}
</style>